// import React, { useState, useEffect } from 'react';
// import { IoMdClose } from 'react-icons/io';
// import './ChangePasswordModal.css';

// const defaultRoles = [
//   { value: '', label: 'Select Role' },
//   { value: 'BM', label: 'BM' },
//   { value: 'BCM', label: 'BCM' },
//   { value: 'RO', label: 'RO' },
//   { value: 'OTHER', label: 'Other' },
// ];

// const ChangePasswordModal = ({ closeModal, onSave }) => {
//   const [form, setForm] = useState({
//     branch: '',
//     empId: '',
//     name: '',
//     role: '',
//     newPassword: '',
//     confirmPassword: '',
//   });

//   const [touched, setTouched] = useState({});
//   const [errors, setErrors] = useState({});
//   const [isSaving, setIsSaving] = useState(false);
//   const [globalError, setGlobalError] = useState('');

//   useEffect(() => {
//     setErrors(validate(form));
//   }, [form]);

//   const validate = (values) => {
//     const e = {};
//     if (!values.branch || !values.branch.trim())
//       e.branch = 'Branch is required';
//     if (!values.empId || !values.empId.trim())
//       e.empId = 'Employee ID is required';
//     if (!values.name || !values.name.trim()) e.name = 'Name is required';
//     if (!values.role) e.role = 'Role is required';
//     if (!values.newPassword) e.newPassword = 'New password is required';
//     else if (values.newPassword.length < 8)
//       e.newPassword = 'Password must be at least 8 characters';
//     if (!values.confirmPassword) e.confirmPassword = 'Please confirm password';
//     else if (values.confirmPassword !== values.newPassword)
//       e.confirmPassword = 'Passwords do not match';
//     return e;
//   };

//   const handleChange = (field) => (ev) => {
//     setForm((p) => ({ ...p, [field]: ev.target.value }));
//     setGlobalError('');
//   };

//   const handleBlur = (field) => () => {
//     setTouched((p) => ({ ...p, [field]: true }));
//   };

//   const handleSubmit = async (ev) => {
//     ev.preventDefault();
//     setTouched({
//       branch: true,
//       empId: true,
//       name: true,
//       role: true,
//       newPassword: true,
//       confirmPassword: true,
//     });

//     const currentErrors = validate(form);
//     if (Object.keys(currentErrors).length > 0) {
//       setErrors(currentErrors);
//       return;
//     }

//     setIsSaving(true);
//     setGlobalError('');

//     const payload = {
//       branch: form.branch.trim(),
//       empId: form.empId.trim(),
//       name: form.name.trim(),
//       role: form.role,
//       newPassword: form.newPassword,
//     };

//     try {
//       if (typeof onSave === 'function') {
//         await onSave(payload);
//       } else {
//         await new Promise((r) => setTimeout(r, 700)); // simulate
//       }
//       closeModal();
//     } catch (err) {
//       console.error('Change password save error:', err);
//       setGlobalError(
//         err?.message || 'Failed to save. Please try again or contact admin.'
//       );
//       setIsSaving(false);
//     }
//   };

//   const isFormValid = Object.keys(errors).length === 0;

//   return (
//     <div>
//       <div className="modal-overlay" onClick={closeModal}></div>

//       <div className="add-user-modal" role="dialog" aria-modal="true">
//         <div className="modal-header">
//           <h5>Change Password</h5>
//           <button className="close-btn" onClick={closeModal} aria-label="Close">
//             <IoMdClose />
//           </button>
//         </div>

//         <p className="modal-subtitle">
//           Update an employee's password. Fill required fields and click Save.
//         </p>

//         <form
//           className="add-user-modal-content"
//           onSubmit={handleSubmit}
//           noValidate
//         >
//           {globalError && <div className="error-message">{globalError}</div>}

//           <div className="form-group-row">
//             <div>
//               <label>Enter Branch</label>
//               <input
//                 type="text"
//                 value={form.branch}
//                 onChange={handleChange('branch')}
//                 onBlur={handleBlur('branch')}
//                 placeholder="e.g. B10 - Palwal"
//               />
//               {touched.branch && errors.branch && (
//                 <div className="error-text">{errors.branch}</div>
//               )}
//             </div>
//           </div>

//           <div className="form-group-row">
//             <div>
//               <label>Employee ID</label>
//               <input
//                 type="text"
//                 value={form.empId}
//                 onChange={handleChange('empId')}
//                 onBlur={handleBlur('empId')}
//                 placeholder="1001"
//               />
//               {touched.empId && errors.empId && (
//                 <div className="error-text">{errors.empId}</div>
//               )}
//             </div>
//           </div>

//           <div className="form-group-row">
//             <div>
//               <label>Name</label>
//               <input
//                 type="text"
//                 value={form.name}
//                 onChange={handleChange('name')}
//                 onBlur={handleBlur('name')}
//                 placeholder="Full name"
//               />
//               {touched.name && errors.name && (
//                 <div className="error-text">{errors.name}</div>
//               )}
//             </div>
//           </div>

//           <div className="form-group-row">
//             <div>
//               <label>Role</label>
//               <select
//                 value={form.role}
//                 onChange={handleChange('role')}
//                 onBlur={handleBlur('role')}
//               >
//                 {defaultRoles.map((r) => (
//                   <option key={r.value} value={r.value}>
//                     {r.label}
//                   </option>
//                 ))}
//               </select>
//               {touched.role && errors.role && (
//                 <div className="error-text">{errors.role}</div>
//               )}
//             </div>
//           </div>

//           <div className="form-group-row">
//             <div>
//               <label>New Password</label>
//               <input
//                 type="password"
//                 value={form.newPassword}
//                 onChange={handleChange('newPassword')}
//                 onBlur={handleBlur('newPassword')}
//                 placeholder="At least 8 characters"
//               />
//               {touched.newPassword && errors.newPassword && (
//                 <div className="error-text">{errors.newPassword}</div>
//               )}
//             </div>
//           </div>

//           <div className="form-group-row">
//             <div>
//               <label>Re-enter / Confirm Password</label>
//               <input
//                 type="password"
//                 value={form.confirmPassword}
//                 onChange={handleChange('confirmPassword')}
//                 onBlur={handleBlur('confirmPassword')}
//                 placeholder="Confirm password"
//               />
//               {touched.confirmPassword && errors.confirmPassword && (
//                 <div className="error-text">{errors.confirmPassword}</div>
//               )}
//             </div>
//           </div>

//           <div className="modal-actions">
//             <button type="submit" className="add-user-btn">
//               {isSaving ? 'Saving...' : 'Save'}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ChangePasswordModal;

import React, { useEffect, useRef, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { IoSearch } from 'react-icons/io5';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import axios from 'axios';
import './ChangePasswordModal.css';
import { toast } from 'react-toastify';

const defaultRoles = [
  { value: '', label: 'Select Role' },
  { value: 'BM', label: 'BM' },
  { value: 'BCM', label: 'BCM' },
  { value: 'RO', label: 'RO' },
  { value: 'OTHER', label: 'Other' },
];

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const ChangePasswordModal = ({ closeModal, onSave }) => {
  const [form, setForm] = useState({
    branch: '',
    empId: '',
    name: '',
    role: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [branches, setBranches] = useState([]);
  const [filteredBranches, setFilteredBranches] = useState([]);
  const [branchSearch, setBranchSearch] = useState('');
  const [showBranchDropdown, setShowBranchDropdown] = useState(false);
  const [selectedBranchDisplay, setSelectedBranchDisplay] = useState('');
  const [loadingBranches, setLoadingBranches] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [globalError, setGlobalError] = useState('');
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});

  const [isProfileAutoFilled, setIsProfileAutoFilled] = useState(false);
  const [allowManualNameRole, setAllowManualNameRole] = useState(false);
  const [isFetchingProfile, setIsFetchingProfile] = useState(false);

  const [branchOfficers, setBranchOfficers] = useState([]);
  const [officerSearch, setOfficerSearch] = useState('');
  const [filteredOfficers, setFilteredOfficers] = useState([]);
  const [showOfficerDropdown, setShowOfficerDropdown] = useState(false);
  const [suppressDropdown, setSuppressDropdown] = useState(false);


  const empIdDebounce = useRef(null);
  const dropdownRef = useRef(null);
  const branchInputRef = useRef(null);

  const getToken = () => {
    try {
      const raw =
        sessionStorage.getItem('tokens') || sessionStorage.getItem('token') || '';
      if (!raw) return '';
      try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          const t =
            parsed.token ||
            parsed.accessToken ||
            parsed.access_token ||
            parsed.refreshToken ||
            '';
          if (typeof t === 'string' && t.trim())
            return t.trim().replace(/^Bearer\s+/i, '');
        }
      } catch {}
      return String(raw)
        .trim()
        .replace(/^Bearer\s+/i, '');
    } catch (e) {
      console.error('getToken error', e);
      return '';
    }
  };

  const looksLikeJwt = (t) => {
    if (!t || typeof t !== 'string') return false;
    const parts = t.split('.');
    return parts.length === 3 && parts.every(Boolean);
  };

  const ensureTokenOrSetError = () => {
    const token = getToken();
    if (!token) {
      setGlobalError('Authentication token not found. Please login.');
      return null;
    }
    if (!looksLikeJwt(token)) {
      setGlobalError('Stored token appears malformed. Please login again.');
      return null;
    }
    return token;
  };

  useEffect(() => {
    const fetchBranches = async () => {
      setLoadingBranches(true);
      const token = ensureTokenOrSetError();
      if (!token) {
        setLoadingBranches(false);
        return;
      }
      try {
        const res = await axios.get(
          `${API_BASE}/officer/get-branch-report?page=1&limit=2000&is_download=false`,
          {
            headers: { Authorization: `Bearer ${token}`, accept: '*/*' },
          }
        );
        if (res.data?.status && res.data?.data?.branch_data) {
          setBranches(res.data.data.branch_data);
        } else {
          setBranches([]);
        }
      } catch (err) {
        console.error('Failed to load branches', err);
        if (err.response?.status === 401) {
          setGlobalError(
            'Authentication failed (invalid/expired token). Please login again.'
          );
        } else {
          setGlobalError('Failed to load branches. Try again later.');
        }
      } finally {
        setLoadingBranches(false);
      }
    };
    fetchBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setErrors(validate(form));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        branchInputRef.current &&
        !branchInputRef.current.contains(event.target)
      ) {
        setShowBranchDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const q = officerSearch.toLowerCase();
    
    setFilteredOfficers(
      branchOfficers.filter(
        (o) =>
          (o.emp_id || "").toLowerCase().includes(q) ||
          (o.first_name || "").toLowerCase().includes(q) ||
          (o.last_name || "").toLowerCase().includes(q)
      )
    );

    // if (officerSearch.trim() !== "") setShowOfficerDropdown(true);
    // else setShowOfficerDropdown(false);
    if (suppressDropdown) {
      setShowOfficerDropdown(false);
      setSuppressDropdown(false);
      return;
    }

    if (officerSearch.trim() !== "") {
      setShowOfficerDropdown(true);
    } else {
      setShowOfficerDropdown(false);
    }

  }, [officerSearch, branchOfficers]);

  const validate = (v) => {
    const e = {};
    if (!v.branch || !v.branch.trim()) e.branch = 'Branch is required';
    if (!v.empId || !v.empId.trim()) e.empId = 'Employee ID is required';
    if (!v.name || !v.name.trim()) e.name = 'Name is required';
    if (!v.role) e.role = 'Role is required';
    if (!v.newPassword) e.newPassword = 'New password is required';
    else if (v.newPassword.length < 8)
      e.newPassword = 'Password must be at least 8 characters';
    else if (!/[A-Z]/.test(v.newPassword))
      e.newPassword = 'Must include at least 1 uppercase letter';
    else if (!/[0-9]/.test(v.newPassword))
      e.newPassword = 'Must include at least 1 number';
    else if (!/[!@#$%^&*(),.?":{}|<>_\-]/.test(v.newPassword))
      e.newPassword = 'Must include at least 1 special character';
    if (!v.confirmPassword) e.confirmPassword = 'Please confirm password';
    else if (v.confirmPassword !== v.newPassword)
      e.confirmPassword = 'Passwords do not match';
    return e;
  };

  const handleChange = (field) => (ev) => {
    const value = ev.target.value;
    setGlobalError('');
    setForm((p) => ({ ...p, [field]: value }));

    // if (field === 'empId') {
    //   setIsProfileAutoFilled(false);
    //   setAllowManualNameRole(false);
    //   setForm((p) => ({ ...p, name: '', role: '', branch: '' }));
    //   setSelectedBranchDisplay('');
    //   setBranchSearch('');

    //   if (empIdDebounce.current) clearTimeout(empIdDebounce.current);
    //   empIdDebounce.current = setTimeout(() => {
    //     if (value.trim()) fetchProfile(value.trim());
    //   }, 400);
    // }
  };

  const handleBlur = (field) => () => {
    setTouched((p) => ({ ...p, [field]: true }));
  };

  const fetchProfile = async (empId) => {
    const token = ensureTokenOrSetError();
    if (!token) return;

    setIsFetchingProfile(true);
    try {
      const res = await axios.get(
        `${API_BASE}/officer/get-profile-via-emp-id/${encodeURIComponent(
          empId
        )}`,
        {
          headers: { Authorization: `Bearer ${token}`, accept: '*/*' },
        }
      );

      if (res.data?.status && res.data?.data) {
        const d = res.data.data;
        const fullName = `${d.first_name || ''} ${d.last_name || ''}`.trim();
        const branchCode = d.branch_code || '';
        const roleCode = d.role_code || '';

        const matchedBranch = branches.find(
          (b) => b.branch_code === branchCode
        );

        setForm((p) => ({
          ...p,
          name: fullName,
          role: roleCode,
          branch: matchedBranch ? matchedBranch.branch_code : branchCode,
        }));

        if (matchedBranch) {
          const display = `${matchedBranch.branch_name}: ${matchedBranch.branch_code}`;
          setBranchSearch(display);
          setSelectedBranchDisplay(display);
        } else if (branchCode) {
          setBranchSearch(branchCode);
          setSelectedBranchDisplay(branchCode);
        }

        setIsProfileAutoFilled(true);
        setAllowManualNameRole(false);
        setShowBranchDropdown(false);
        setErrors((prev) => ({ ...prev, name: undefined, role: undefined }));
      } else {
        setIsProfileAutoFilled(false);
        setAllowManualNameRole(true);
      }
    } catch (err) {
      if (err.response?.status === 404) {
        setAllowManualNameRole(true);
        setIsProfileAutoFilled(false);
      } else {
        setAllowManualNameRole(true);
      }
    } finally {
      setIsFetchingProfile(false);
    }
  };

  const fetchOfficersOfBranch = async (branchCode) => {
    const token = ensureTokenOrSetError();
    if (!token) return;

    try {
      const res = await axios.get(
        `${API_BASE}/officer/get-branch-officer-report?branch_code=${branchCode}&page=1&limit=1000`,
        {
          headers: { Authorization: `Bearer ${token}`, accept: "*/*" },
        }
      );

      if (res.data?.status && res.data?.data?.officers?.length > 0) {
        const officerDetails = res.data.data.officers[0].officer_details;
        setBranchOfficers(officerDetails);
      } else {
        setBranchOfficers([]);
      }
    } catch (err) {
      console.error("Failed to load officers", err);
      setBranchOfficers([]);
    }
  };


  useEffect(() => {
    if (!branchSearch.trim()) {
      setFilteredBranches([]);
      setShowBranchDropdown(false);
      return;
    }
    const q = branchSearch.toLowerCase();
    setFilteredBranches(
      branches.filter(
        (b) =>
          (b.branch_code || '').toLowerCase().includes(q) ||
          (b.branch_name || '').toLowerCase().includes(q)
      )
    );
    setShowBranchDropdown(true);
  }, [branchSearch, branches]);

  const handleBranchInputChange = (e) => {
    setBranchSearch(e.target.value);
    setForm((p) => ({ ...p, branch: '' }));
    setSelectedBranchDisplay('');
  };

  // const handleBranchSelect = (branch) => {
  //   setForm((p) => ({ ...p, branch: branch.branch_code }));
  //   setSelectedBranchDisplay(`${branch.branch_name}: ${branch.branch_code}`);
  //   setBranchSearch(`${branch.branch_name}: ${branch.branch_code}`);
  //   setShowBranchDropdown(false);
  // };

  const handleBranchSelect = async (branch) => {
    setForm((p) => ({ ...p, branch: branch.branch_code }));
    setSelectedBranchDisplay(`${branch.branch_name}: ${branch.branch_code}`);
    setBranchSearch(`${branch.branch_name}: ${branch.branch_code}`);
    setShowBranchDropdown(false);

    await fetchOfficersOfBranch(branch.branch_code);
  };


  const handleSubmit = async (ev) => {
    ev.preventDefault();

    setTouched({
      branch: true,
      empId: true,
      name: true,
      role: true,
      newPassword: true,
      confirmPassword: true,
    });

    const currentErrors = validate(form);
    if (Object.keys(currentErrors).length > 0) {
      setErrors(currentErrors);
      return;
    }

    const token = ensureTokenOrSetError();
    if (!token) return;

    setIsSaving(true);
    setGlobalError('');

    const payload = {
      emp_id: form.empId.trim(),
      branch_code: form.branch.trim(),
      full_name: form.name.trim(),
      role_code: form.role,
      new_password: form.newPassword,
      confirm_password: form.confirmPassword,
    };

    try {
      const res = await axios.post(
        `${API_BASE}/officer/reset-password-via-admin`,
        payload,
        {
          headers: {
            accept: '*/*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.status) {
        if (typeof onSave === 'function') {
          try {
            await onSave(res.data);
          } catch (e) {
            console.warn('onSave error:', e);
          }
        }
        closeModal();
        toast.success(`Password changed successfully`);
      } else {
        setGlobalError(res.data?.message || 'Failed to reset password');
        toast.error(`Failed to reset password`);
      }
    } catch (err) {
      console.error('Reset API error', err);
      setGlobalError(
        err.response?.data?.message ||
          (err.response?.status === 401
            ? 'Invalid/expired token. Please login again.'
            : 'Failed to reset password')
      );
      toast.error(`Failed to reset password`);
    } finally {
      setIsSaving(false);
    }
  };

  const nameRoleDisabled = isProfileAutoFilled || !allowManualNameRole;

  return (
    <div>
      <div className="modal-overlay" onClick={closeModal}></div>
      <div className="add-user-modal" role="dialog" aria-modal="true">
        <div className="modal-header">
          <h5>Change Password</h5>
          <button className="close-btn" onClick={closeModal} aria-label="Close">
            <IoMdClose />
          </button>
        </div>

        <form className="add-user-modal-content" onSubmit={handleSubmit}>
          {globalError && <div className="error-message">{globalError}</div>}

          {/* BRANCH SEARCH */}
          <div className="form-group-row">
            <div className="branch-search-container">
              <label>Branch</label>
              <div className="search-input-wrapper" ref={dropdownRef}>
                <input
                  ref={branchInputRef}
                  type="text"
                  placeholder={
                    loadingBranches ? 'Loading branches...' : 'Search branch...'
                  }
                  value={branchSearch}
                  onChange={handleBranchInputChange}
                  onFocus={() =>
                    branchSearch &&
                    !isProfileAutoFilled &&
                    setShowBranchDropdown(true)
                  }
                  className="branch-search-input"
                  disabled={isProfileAutoFilled}
                />
                <span className="search-icon-right" aria-hidden="true">
                  <IoSearch />
                </span>

                {showBranchDropdown &&
                  branchSearch.trim() !== '' &&
                  filteredBranches.length > 0 && (
                    <div className="branch-dropdown-results">
                      {filteredBranches.map((branch) => (
                        <div
                          key={branch.branch_code}
                          className="branch-dropdown-item"
                          onClick={() => handleBranchSelect(branch)}
                        >
                          <div className="branch-item-name">
                            <strong>{branch.branch_name}</strong>
                          </div>
                          <div className="branch-item-code">
                            Branch Code: {branch.branch_code}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
              </div>

              {selectedBranchDisplay && (
                <small className="selected-branch-info">
                  ✓ Selected: {selectedBranchDisplay}
                </small>
              )}
              {touched.branch && errors.branch && (
                <div className="error-text">{errors.branch}</div>
              )}
            </div>
          </div>

          {/* EMPLOYEE ID */}
          {/* <div className="form-group-row">
            <div>
              <label>Employee ID</label>
              <input
                type="text"
                value={form.empId}
                onChange={handleChange('empId')}
                onBlur={handleBlur('empId')}
                placeholder="Enter employee ID number"
              />
              {isFetchingProfile && (
                <small
                  style={{
                    color: '#6b7280',
                    fontSize: '0.85rem',
                    marginTop: '4px',
                    display: 'block',
                  }}
                >
                  Fetching employee details...
                </small>
              )}
              {touched.empId && errors.empId && (
                <div className="error-text">{errors.empId}</div>
              )}
            </div>
          </div> */}

          <div className="form-group-row">
            <div className="branch-search-container">
              <label>Employee ID</label>

              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder="Search employee ID..."
                  value={officerSearch}
                  onChange={(e) => setOfficerSearch(e.target.value)}
                  onFocus={() => officerSearch.trim() !== "" && setShowOfficerDropdown(true)}
                  className="branch-search-input"
                />

                <span className="search-icon-right">
                  <IoSearch />
                </span>

                {showOfficerDropdown && filteredOfficers.length > 0 && (
                  <div className="branch-dropdown-results">
                    {filteredOfficers.map((o) => (
                      <div
                        key={o.officer_id}
                        className="branch-dropdown-item"
                        onClick={() => {
                          setSuppressDropdown(true);   // ⭐ prevents dropdown from auto-opening

                          setForm((p) => ({
                            ...p,
                            empId: o.emp_id,
                            name: `${o.first_name} ${o.last_name}`.trim(),
                            role: o.role_code,
                          }));
                          setOfficerSearch(o.emp_id);
                          setShowOfficerDropdown(false);

                          // Ensure the input doesn't regain focus
                          setTimeout(() => {
                            if (document.activeElement instanceof HTMLElement) {
                              document.activeElement.blur();
                            }
                          }, 0);
                        }}
                      >
                        <div className="branch-item-name">
                          <strong>{o.emp_id}</strong> — {o.first_name} {o.last_name}
                        </div>
                        <div className="branch-item-code">
                          Role: {o.role_code}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {touched.empId && errors.empId && (
                <div className="error-text">{errors.empId}</div>
              )}
            </div>
          </div>


          {/* NAME */}
          <div className="form-group-row">
            <div>
              <label>Name</label>
              <input
                type="text"
                value={form.name}
                onChange={(e) =>
                  setForm((p) => ({ ...p, name: e.target.value }))
                }
                onBlur={handleBlur('name')}
                placeholder="Full name"
                disabled={nameRoleDisabled}
                className={isProfileAutoFilled ? 'auto-filled-field' : ''}
              />
              {isProfileAutoFilled && (
                <small
                  style={{
                    color: '#059669',
                    fontSize: '0.85rem',
                    marginTop: '4px',
                    display: 'block',
                  }}
                >
                  ✓ Auto-filled from employee profile
                </small>
              )}
              {touched.name && errors.name && (
                <div className="error-text">{errors.name}</div>
              )}
            </div>
          </div>

          {/* ROLE - LABEL ON TOP, BOX BELOW */}
          <div className="form-group-row">
            <div className="role-field-container">
              <label>Role</label>
              <select
                value={form.role}
                onChange={(e) =>
                  setForm((p) => ({ ...p, role: e.target.value }))
                }
                onBlur={handleBlur('role')}
                disabled={nameRoleDisabled}
                className={`role-select-compact ${
                  isProfileAutoFilled ? 'auto-filled-field' : ''
                }`}
              >
                {defaultRoles.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))}
              </select>
              {isProfileAutoFilled && (
                <small
                  style={{
                    color: '#059669',
                    fontSize: '0.85rem',
                    marginTop: '4px',
                    display: 'block',
                  }}
                >
                  ✓ Auto-filled from employee profile
                </small>
              )}
              {touched.role && errors.role && (
                <div className="error-text">{errors.role}</div>
              )}
            </div>
          </div>

          {/* NEW PASSWORD */}
          <div className="form-group-row">
            <div className="password-wrapper">
              <label>New Password</label>
              <div className="password-input-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={form.newPassword}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, newPassword: e.target.value }))
                  }
                  onBlur={handleBlur('newPassword')}
                  placeholder="Enter new password"
                  className="password-input"
                />
                <span
                  className="eye-icon"
                  onClick={() => setShowPassword((v) => !v)}
                  role="button"
                  tabIndex={0}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                </span>
              </div>
              <small
                style={{
                  color: '#6b7280',
                  fontSize: '0.8rem',
                  display: 'block',
                  marginTop: '4px',
                }}
              >
                Must be different from current password
              </small>
              {touched.newPassword && errors.newPassword && (
                <div className="error-text">{errors.newPassword}</div>
              )}
            </div>
          </div>

          {/* CONFIRM PASSWORD */}
          <div className="form-group-row">
            <div className="password-wrapper">
              <label>Confirm Password</label>
              <div className="password-input-container">
                <input
                  type={showConfirm ? 'text' : 'password'}
                  value={form.confirmPassword}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, confirmPassword: e.target.value }))
                  }
                  onBlur={handleBlur('confirmPassword')}
                  placeholder="Re-enter password"
                  className="password-input"
                />
                <span
                  className="eye-icon"
                  onClick={() => setShowConfirm((v) => !v)}
                  role="button"
                  tabIndex={0}
                  aria-label={showConfirm ? 'Hide password' : 'Show password'}
                >
                  {showConfirm ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                </span>
              </div>
              {touched.confirmPassword && errors.confirmPassword && (
                <div className="error-text">{errors.confirmPassword}</div>
              )}
            </div>
          </div>

          {/* SUBMIT BUTTON */}
          <div className="modal-actions">
            <button type="submit" className="add-user-btn" disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
